import Vue from 'vue'
import { mapGetters } from 'vuex'
import classApi from '@/api/class'

export default {
    computed: {
        ...mapGetters('user', ['isLogin']),
    },
    methods: {
        addCollection(product) {
            if (!this.isLogin) {
                this.$root.$emit('bv::show::modal', 'login_modal');

                return;
            }

            classApi.addCollection({ InitID: this.product.InitID }, () => {
                if (product.Favorites) { 
                    Vue.set(product, 'Favorites', false);
                } else {
                    Vue.set(product, 'Favorites', true);
                }
            });
        },
    },
}